import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpertiseStatsSection"] */ "/tmp/8dee0cb9639da04/components/sections/ExpertiseStatsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/QRLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRShowcase"] */ "/tmp/8dee0cb9639da04/components/sections/QRShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionComparison"] */ "/tmp/8dee0cb9639da04/components/sections/SolutionComparison.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/TechPartnersSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8dee0cb9639da04/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VenuesSlider"] */ "/tmp/8dee0cb9639da04/components/sections/VenuesSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BenefitCard"] */ "/tmp/8dee0cb9639da04/components/ui/BenefitCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingFactorCard"] */ "/tmp/8dee0cb9639da04/components/ui/PricingFactorCard.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/app/[locale]/qr-bestellen/QRPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
